// extracted by mini-css-extract-plugin
module.exports = {"layout":"LayoutContainer_layout__M8Xc2","standard":"LayoutContainer_standard___x_xq","fullwidth":"LayoutContainer_fullwidth__vyRxz","bg":"LayoutContainer_bg__TJ5Kp"};